import { EntityRequestHoliday } from "../../entity/EntityRequestHoliday";

export class DtoRequestHolidaysPostRes extends EntityRequestHoliday {}
